import { IRecentProfessional, IRecentProfessionalApi } from './recentProfessionalsTypes';

function toRecentProfessional(businessApi: IRecentProfessionalApi): IRecentProfessional {
  return {
    id: businessApi.id,
    jobDatetime: businessApi.job_datetime,
    profession: businessApi.profession,
    professional: {
      fullName: businessApi.professional.full_name,
      id: businessApi.professional.id,
      image: businessApi.professional.image,
      overallProfessionalRating: businessApi.professional.overallProfessionalRating,
      professions: businessApi.professional.professions,
      yearsOfExperience: businessApi.professional.yearsOfExperience,
      badges: businessApi.professional.badges ?? [],
      education: businessApi.professional.education ?? {},
    },
    professionalRating: businessApi.professionalRating,
    ratingCount: businessApi.ratingCount,
    hasMarkedAvailable: businessApi.hasMarkedAvailable,
  };
}

export const recentProfessionalsAdapter = { toRecentProfessional };
